import { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import { FaPlus } from "react-icons/fa6";
import { MdOutlineFileDownload } from "react-icons/md";

import "../Usuarios/usuarios.css";
import buttonStyles from "../../../../styles/Button.module.css";
import menuStyle from "../../../../styles/Menu.module.css";
import styles from "./../tooltip.module.css";

import ChangeCreditLimitModal from "../LimitLevels/ChangeCreditLimitModal";
import ChangeLevelModal from "../LimitLevels/ChangeLevelModal";
import TableOptionCheck, { FilterType } from "../Productos/TableOptionCheck";
import SearchBar from "../SearchBar";
import CreateAsociados from "./CreateAsociados";

import AsociadosTable from "./AsociadosTable";
import * as api from "helper/helper";
import { Sections } from "../../data/navItem";
import { PermissionsForSection } from "../auth";
import { buildPageButtonsInfo } from "../../helperFunctions/PagedFetch";
import FilterButton from "../FilterButton/FilterButton";
import { useStore } from "../../../../store/store";
import PagingBar from "../Navigations/PagingBar";
import ChangeCongeladoModal from "../LimitLevels/ChangeCongeladoModal";
import ExportCSV from "../ExportCSV";
import { buildName, Singleton } from "helper/tools";
import { handleStatus } from "../../helperFunctions/helpers";

const Child2 = ({
  filtros,
  filtrosRef,
  clearCallback,
  Menus,
  status,
  docu,
  resizeRef,
  handleStatusClick,
  handleLimiteCreditoRangeChange,
  handleCreditoRangeChange,
  handleCreditoRangePercentageChange,
  handleCreditoRangeDisponibleChange,
  handleDocuClick,
  niveles,
  handleNivelesClick,
}) => {
  const store = useStore((state) => state);

  useEffect(() => console.log(`again rendered`));
  return (
    <div className="btn-group1" style={{ display: "flex", columnGap: "6px" }}>
      {filtros.map((filtro, index) => {
        return (
          <>
            <FilterButton
              key={index}
              ref={(el) => (filtrosRef.current[index] = el)}
              name={filtro.name}
              clearCallback={(ble) => clearCallback(filtro)}
            >
              <ul
                className={`dropdown-menu ${menuStyle.height_50_scroll}`}
                aria-labelledby="dropdownMenuClickableInside"
              >
                {filtro.type === Menus.Niveles &&
                  niveles.map((item, index) => {
                    return (
                      <TableOptionCheck
                        key={index}
                        ref={resizeRef}
                        filterType={FilterType.OptionCheck}
                        item={item}
                        onClick={handleNivelesClick}
                      />
                    );
                  })}

                {filtro.type === Menus.Status &&
                  status.map((item, index) => {
                    return (
                      <TableOptionCheck
                        key={index}
                        ref={resizeRef}
                        item={item}
                        onClick={handleStatusClick}
                      />
                    );
                  })}

                {filtro.type === Menus.Documentacion &&
                  docu.map((item, index) => {
                    return (
                      <TableOptionCheck
                        key={index}
                        ref={resizeRef}
                        item={item}
                        onClick={handleDocuClick}
                      />
                    );
                  })}
                {filtro.type === Menus.LimiteCreditoRange && (
                  <TableOptionCheck
                    key={index}
                    ref={resizeRef}
                    filterType={FilterType.Range}
                    item={filtro}
                    sliderValues={[0, 50, 100, 150, 200, 250, 300]}
                    onChange={handleLimiteCreditoRangeChange}
                  />
                )}
                {filtro.type === Menus.CreditoRange && (
                  <TableOptionCheck
                    key={index}
                    ref={resizeRef}
                    filterType={FilterType.Range}
                    item={filtro}
                    sliderValues={[0, 50, 100, 150, 200, 250, 300]}
                    onChange={handleCreditoRangeChange}
                  />
                )}
                {filtro.type === Menus.CreditoDispuestoRange && (
                  <TableOptionCheck
                    key={index}
                    ref={resizeRef}
                    filterType={FilterType.Range}
                    item={filtro}
                    sliderValues={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                    onChange={handleCreditoRangePercentageChange}
                  />
                )}
                {filtro.type === Menus.CreditoDisponibleRange && (
                  <TableOptionCheck
                    key={index}
                    ref={resizeRef}
                    filterType={FilterType.Range}
                    item={filtro}
                    sliderValues={[0, 50, 100, 150, 200, 250, 300]}
                    onChange={handleCreditoRangeDisponibleChange}
                  />
                )}
              </ul>
            </FilterButton>
          </>
        );
      })}
    </div>
  );
};
/*
const Child2Ex = ({
  filtros,
  filtrosRef,
  clearCallback,
  Menus,
  status,
  resizeRef,
  handleStatusClick,
  handleLimiteCreditoRangeChange,
  handleCreditoRangeChange,
  handleCreditoRangePercentageChange,
  niveles,
  handleNivelesClick,
}) => {
  const state = useStore((state) => state);

  useEffect(() => console.log(`again rendered`, state));
  return (
    <div className="btn-group1" style={{ display: "flex", columnGap: "6px" }}>
      {filtros.map((item, index) => {
        return (
          <>
            <FilterButton
              key={index}
              ref={(el) => (filtrosRef.current[index] = el)}
              name={item.name}
              clearCallback={(ble) => clearCallback(item)}
            >
              <ul
                className={`dropdown-menu ${menuStyle.height_50_scroll}`}
                aria-labelledby="dropdownMenuClickableInside"
              >
                {item.type === Menus.Status &&
                  status.map((item, index) => {
                    return (
                      <TableOptionCheck
                        key={index}
                        ref={resizeRef}
                        item={item}
                        onClick={handleStatusClick}
                      />
                    );
                  })}
                {item.type === Menus.LimiteCreditoRange && (
                  <TableOptionCheck
                    key={index}
                    ref={resizeRef}
                    filterType={FilterType.Range}
                    item={item}
                    sliderValues={[0, 50, 100, 150, 200, 250, 300]}
                    onChange={handleLimiteCreditoRangeChange}
                  />
                )}
                {item.type === Menus.CreditoRange && (
                  <TableOptionCheck
                    key={index}
                    ref={resizeRef}
                    filterType={FilterType.Range}
                    item={item}
                    sliderValues={[0, 50, 100, 150, 200, 250, 300]}
                    onChange={handleCreditoRangeChange}
                  />
                )}
                {item.type === Menus.CreditoDispuestoRange && (
                  <TableOptionCheck
                    key={index}
                    ref={resizeRef}
                    filterType={FilterType.Range}
                    item={item}
                    sliderValues={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                    onChange={handleCreditoRangePercentageChange}
                  />
                )}
                {item.type === Menus.CreditoDisponibleRange && (
                  <TableOptionCheck
                    key={index}
                    ref={resizeRef}
                    filterType={FilterType.Range}
                    item={item}
                    sliderValues={[0, 50, 100, 150, 200, 250, 300]}
                    onChange={handleCreditoRangePercentageChange}
                  />
                )}
                {item.type === Menus.Niveles &&
                  niveles.map((item, index) => {
                    return (
                      <TableOptionCheck
                        key={index}
                        ref={resizeRef}
                        filterType={FilterType.OptionCheck}
                        item={item}
                        onClick={handleNivelesClick}
                      />
                    );
                  })}
                {item.type === Menus.Documentacion &&
                  status.map((item, index) => {
                    return (
                      <TableOptionCheck
                        key={index}
                        ref={resizeRef}
                        item={item}
                        onClick={handleStatusClick}
                      />
                    );
                  })}
              </ul>
            </FilterButton>
          </>
        );
      })}
    </div>
  );
};*/

const areEqual = (prevProps, nextProps) => {
  return prevProps.value === nextProps.value;
};

//const Child2wMemo = memo(Child2, areEqual);
export default function AsociadosCatalogo() {
  const Menus = {
    Status: 0,
    Niveles: 1,
    LimiteCreditoRange: 2,
    CreditoRange: 3,
    CreditoDispuestoRange: 4,
    CreditoDisponibleRange: 5,
    Documentacion: 6,
  };

  const StatusValues = {
    Activo: 0,
    Inactivo: 1,
    Congelado: 2,
  };

  const DocumentacionValues = {
    Con: 0,
    Sin: 1,
  };

  const store = useStore((state) => state);

  const rangeCredito = useRef(null);

  const createAsociadosRef = useRef();
  const filtrosRef = useRef([]);
  const changeCreditLimitRef = useRef();
  const changeLevelRef = useRef();
  const changeCongeladoRef = useRef();
  const resizeRef = useRef();

  const csvRef = useRef();

  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [asociados, setAsociados] = useState(null);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const [status, setStatus] = useState([
    {
      nombre: "Activo",
      value: StatusValues.Activo,
      id: 1,
      pos: 0,
      checked: false,
    },
    {
      nombre: "Inactivo",
      value: StatusValues.Inactivo,
      id: 2,
      pos: 1,
      checked: false,
    },
    {
      nombre: "Congelado",
      value: StatusValues.Congelado,
      id: 3,
      pos: 2,
      checked: false,
    },
    //  { nombre: "Draft", value: "draft", id: 3 },
  ]);

  const [docu, setDocu] = useState([
    {
      nombre: "Con",
      value: DocumentacionValues.Con,
      id: 1,
      pos: 0,
      checked: false,
    },
    {
      nombre: "Sin",
      value: DocumentacionValues.Sin,
      id: 2,
      pos: 1,
      checked: false,
    },
    //  { nombre: "Draft", value: "draft", id: 3 },
  ]);

  const [filtros] = useState([
    {
      type: Menus.Niveles,
      name: "Niveles",
    },
    {
      type: Menus.Status,
      name: "Estatus",
    },

    {
      type: Menus.Documentacion,
      name: "Documentación",
    },
    {
      type: Menus.LimiteCreditoRange,
      name: "Rango Limite Credito",
    },
    {
      type: Menus.CreditoRange,
      name: "Rango Credito Dispuesto",
    },
    {
      type: Menus.CreditoDispuestoRange,
      name: "Rango % Credito Dispuesto",
    },
    {
      type: Menus.CreditoDisponibleRange,
      name: "Rango Credito Disponible",
    },
  ]);

  /** FILTERS */
  //const [asociados, setAsociados] = useState({});
  const [niveles, setNiveles] = useState([]);

  /** PAGING */
  const [searchCriteria, setSearchCriteria] = useState({});
  /*  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });*/

  const fetchData = async (resetPageNumber = true) => {
    const responseNiveles = await api.niveles().catch((error) => {
      toast.error("Error al pedir Niveles.");
      setIsLoading(false);
    });

    if (!responseNiveles) return;

    const autoNiveles = responseNiveles.data.map((item) => {
      return { id: item.id, nombre: item.nombre };
    });

    setNiveles(autoNiveles);

    let criteria = searchCriteria;

    if (resetPageNumber) {
      /// reset pag info
      store.pagingInfoRef.resetPageInfo();
    }

    //pagingInfoRef.current.resetPageInfo();

    criteria = store.pagingInfoRef.buildFetch(criteria);
    //criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  };

  useEffect(() => {
    fetchData();

    store.updateGoToPage(goToPage);
    store.updateGoPreviousPage(goPreviousPage);
    store.updateGoNextPage(goNextPage);

    const newPermissions = PermissionsForSection(Sections.Asociados);
    setPermissions(newPermissions);
  }, []);

  function createAsociado(event) {
    console.log(event);
    loadItem({});
  }

  function reloadAsociados() {
    fetchData(false);
  }

  function loadItem(item) {
    if (!permissions.canVerDetalle) return;

    console.log(createAsociadosRef);
    setModalData(item);

    createAsociadosRef.current.toggleModal();
  }

  function openChangeCreditLimit(event, data) {
    console.log(event);
    setModalData(data);
    changeCreditLimitRef.current.toggleModal();
  }

  function openChangeLevel(event, data) {
    console.log(event);
    setModalData(data);
    changeLevelRef.current.toggleModal();
  }

  function openCongelarDescongelar(event, data) {
    console.log(event);
    setModalData(data);
    changeCongeladoRef.current.toggleModal();
  }

  /**
   * Search handler
   */

  const onChangeSearchText = (e) => {
    console.log("text search change " + e);

    let criteria = searchCriteria;

    if (e === null) {
      delete criteria["texto"];
    } else {
      criteria["texto"] = e;
    }

    /// reset pag info
    store.pagingInfoRef.resetPageInfo();
    criteria = store.pagingInfoRef.buildFetch(criteria);

    //pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);
  };

  function clearNivelesFilter(s) {
    niveles.forEach((item) => {
      item.checked = false;
    });

    setNiveles(niveles.slice());

    updateNivelesCriteria([]);

    filtrosRef.current[Menus.Niveles].hideMenu();
  }

  const handleNivelesClick = (event, item, options) => {
    let criteria = searchCriteria;
    let nivelIds = criteria["NivelIds"] ?? [];

    let itemId = item.id;
    if (event.currentTarget.checked && !nivelIds.includes(item.id)) {
      nivelIds.push(itemId);
    } else if (!event.currentTarget.checked && nivelIds.includes(item.id)) {
      nivelIds = nivelIds.filter((f) => f !== itemId);
    }

    updateNivelesCriteria(nivelIds);
  };

  const updateNivelesCriteria = (nivelIds) => {
    let criteria = searchCriteria;

    criteria["NivelIds"] = nivelIds;
    setSearchCriteria(criteria);

    /// reset pag info
    //  pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);
    store.pagingInfoRef.resetPageInfo();
    criteria = store.pagingInfoRef.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Niveles;
    });

    if (index === -1) {
      return;
    }
    var nivelesNames = "";
    if (nivelIds.length > 0) {
      //
      const nivelesFilter = niveles.filter((currItem) => {
        return nivelIds.includes(currItem.id);
      });

      nivelesNames = nivelesFilter
        .map(function (depa) {
          return depa.nombre;
        })
        .join(", ");
    }

    filtrosRef.current[index].toka(nivelesNames);
  };

  function clearCreditoRange(s) {
    handleCreditoRangeChange("");
    filtrosRef.current[Menus.LimiteCreditoRange].hideMenu();
  }

  function clearLimiteCreditoRange(s) {
    handleLimiteCreditoRangeChange("");
    filtrosRef.current[Menus.CreditoRange].hideMenu();
  }

  function clearCreditoPercentageRange(s) {
    handleCreditoRangePercentageChange("");
    filtrosRef.current[Menus.CreditoDispuestoRange].hideMenu();
  }

  function clearCreditoDisponibleRange(s) {
    handleCreditoRangeDisponibleChange("");
    filtrosRef.current[Menus.CreditoDisponibleRange].hideMenu();
  }

  const handleLimiteCreditoRangeChange = (event, item, options) => {
    let criteria = searchCriteria;

    if (event.length > 0) {
      const aRange = event.split(",").map((str) => {
        return parseInt(str) * 1000;
      });

      rangeCredito.current = aRange;

      criteria["LimiteCreditoRange"] = aRange;
    } else {
      delete criteria["LimiteCreditoRange"];
    }

    /// reset pag info
    //pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);

    store.pagingInfoRef.resetPageInfo();
    criteria = store.pagingInfoRef.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.LimiteCreditoRange;
    });

    if (index === -1) {
      return;
    }

    filtrosRef.current[index].toka(event);
  };

  const handleCreditoRangeChange = (event, item, options) => {
    let criteria = searchCriteria;

    if (event.length > 0) {
      const aRange = event.split(",").map((str) => {
        return parseInt(str) * 1000;
      });

      rangeCredito.current = aRange;
      //currentStatus[item.pos] = event.currentTarget.checked;

      criteria["CreditoRange"] = aRange;
    } else {
      delete criteria["CreditoRange"];
    }

    /// reset pag info
    //  pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);

    store.pagingInfoRef.resetPageInfo();
    criteria = store.pagingInfoRef.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.CreditoRange;
    });

    if (index === -1) {
      return;
    }

    filtrosRef.current[index].toka(event);
  };

  const handleCreditoRangePercentageChange = (event, item, options) => {
    let criteria = searchCriteria;

    if (event.length > 0) {
      const aRange = event.split(",").map((str) => {
        return parseInt(str);
      });

      rangeCredito.current = aRange;

      criteria["CreditoPorcentajeRange"] = aRange;
    } else {
      delete criteria["CreditoPorcentajeRange"];
    }

    /// reset pag info
    //pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);

    store.pagingInfoRef.resetPageInfo();
    criteria = store.pagingInfoRef.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.CreditoDispuestoRange;
    });

    if (index === -1) {
      return;
    }

    filtrosRef.current[index].toka(event);
  };

  const handleCreditoRangeDisponibleChange = (event, item, options) => {
    let criteria = searchCriteria;

    if (event.length > 0) {
      const aRange = event.split(",").map((str) => {
        return parseInt(str) * 1000;
      });

      rangeCredito.current = aRange;

      criteria["CreditoDisponibleRange"] = aRange;
    } else {
      delete criteria["CreditoDisponibleRange"];
    }

    /// reset pag info
    //pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);

    store.pagingInfoRef.resetPageInfo();
    criteria = store.pagingInfoRef.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.CreditoDisponibleRange;
    });

    if (index === -1) {
      return;
    }

    filtrosRef.current[index].toka(event);
  };

  function clearCallback(item) {
    filtros.forEach((value, index) => {
      if (value.type === Menus.Niveles && item.type === Menus.Niveles) {
        clearNivelesFilter();
      } else if (value.type === Menus.Status && item.type === Menus.Status) {
        clearStatusFilter();
      } else if (
        value.type === Menus.Documentacion &&
        item.type === Menus.Documentacion
      ) {
        clearDocumentacionFilter();
      } else if (
        value.type === Menus.LimiteCreditoRange &&
        item.type === Menus.LimiteCreditoRange
      ) {
        clearLimiteCreditoRange();
      } else if (
        value.type === Menus.CreditoRange &&
        item.type === Menus.CreditoRange
      ) {
        clearCreditoRange();
      } else if (
        value.type === Menus.CreditoDispuestoRange &&
        item.type === Menus.CreditoDispuestoRange
      ) {
        clearCreditoPercentageRange();
      } else if (
        value.type === Menus.CreditoDisponibleRange &&
        item.type === Menus.CreditoDisponibleRange
      ) {
        clearCreditoDisponibleRange();
      }
    });
  }

  const clearStatusFilter = () => {
    status.forEach((item) => {
      item.checked = false;
    });

    setStatus(status.slice());

    updateStatusCriteria(undefined);

    filtrosRef.current[Menus.Status].hideMenu();
  };

  const clearDocumentacionFilter = () => {
    docu.forEach((item) => {
      item.checked = false;
    });

    setDocu(docu.slice());

    updateDocuCriteria(undefined);

    filtrosRef.current[Menus.Documentacion].hideMenu();
  };

  const handleStatusClick = (event, item, options) => {
    item.checked = !item.checked;

    const isActivo = status.find((item) => {
      return item.value === StatusValues.Activo && item.checked;
    })?.checked;
    const isInactivo = status.find((item) => {
      return item.value === StatusValues.Inactivo && item.checked;
    })?.checked;
    const isCongelado = status.find((item) => {
      return item.value === StatusValues.Congelado && item.checked;
    })?.checked;

    let checked = isActivo;
    if (!(isActivo ^ isInactivo)) {
      //delete criteria["isActivo"];
      checked = undefined;
    } else {
      //let checked = isActivo;
      if (isInactivo) {
        checked = false;
      }
      //criteria["isActivo"] = checked;
    }

    updateStatusCriteria(checked, isCongelado);
  };

  const handleDocuClick = (event, item, options) => {
    item.checked = !item.checked;

    const isCon = docu.find((item) => {
      return item.value === DocumentacionValues.Con && item.checked;
    })?.checked;
    const isSin = docu.find((item) => {
      return item.value === DocumentacionValues.Sin && item.checked;
    })?.checked;

    let checked = isCon;
    if (!(isCon ^ isSin)) {
      //delete criteria["isActivo"];
      checked = undefined;
    } else {
      //let checked = isActivo;
      if (isSin) {
        checked = false;
      }
      //criteria["isActivo"] = checked;
    }

    updateDocuCriteria(checked);
  };

  const updateStatusCriteria = (statusValue, congeladoValue) => {
    let criteria = searchCriteria;
    if (statusValue === undefined) {
      delete criteria["isActivo"];
    } else {
      criteria["isActivo"] = statusValue;
    }

    criteria["isCongelado"] = congeladoValue;
    setSearchCriteria(criteria);

    /// reset pag info
    //pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);

    store.pagingInfoRef.resetPageInfo();
    criteria = store.pagingInfoRef.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Status;
    });

    if (index === -1) {
      return;
    }
    var statusNames = "";
    //
    const statuses = status.flatMap((currItem, index) => {
      return currItem.checked ? currItem.nombre : [];
    });

    statusNames = statuses.join(", ");

    filtrosRef.current[index].toka(statusNames);
  };

  const updateDocuCriteria = (docuValue) => {
    let criteria = searchCriteria;
    if (docuValue === undefined) {
      delete criteria["HasDocumentacion"];
    } else {
      criteria["HasDocumentacion"] = docuValue;
    }
    setSearchCriteria(criteria);

    /// reset pag info
    //pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);

    store.pagingInfoRef.resetPageInfo();
    criteria = store.pagingInfoRef.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Documentacion;
    });

    if (index === -1) {
      return;
    }
    var docusNames = "";
    //
    const docuses = docu.flatMap((currItem, index) => {
      return currItem.checked ? currItem.nombre : [];
    });

    docusNames = docuses.join(", ");

    filtrosRef.current[index].toka(docusNames);
  };

  const searchFetchData = async (criteria) => {
    //setIsLoading(true);
    const response = await api.searchAsociados(criteria).catch((error) => {
      toast.error("Error al buscar Asociados.");
      setIsLoading(false);
    });
    if (!response) return;

    const { totalPages, count, isFirstPage, isLastPage } = response.data;

    const { rangePage, newPageNumber } = buildPageButtonsInfo(response.data);

    store.pagingInfoRef.updatePageNumber(newPageNumber);
    store.updatePageButtons(rangePage);
    store.updateResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });

    /*pagingInfoRef.current.updatePageNumber(newPageNumber);

    setPageButtons(rangePage);

    setResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });*/

    //setAsociados(response.data.subset);
    store.updateAsociados(response.data.subset);
    setAsociados(response.data.subset);

    //  setIsLoading(false);
  };

  function goPreviousPage() {
    let page = store.pagingInfoRef.pageNumber();
    page -= 1;
    goToPage(page);
  }

  function goNextPage() {
    //let page = pagingInfoRef.current.pageNumber();
    let page = store.pagingInfoRef.pageNumber();
    page += 1;
    goToPage(page);
  }

  function goToPage(pageNumber) {
    let criteria = searchCriteria;
    //pagingInfoRef.current.updatePageNumber(pageNumber);
    //criteria = pagingInfoRef.current.buildFetch(criteria);

    store.pagingInfoRef.updatePageNumber(pageNumber);
    criteria = store.pagingInfoRef.buildFetch(criteria);

    searchFetchData(criteria);
  }

  function handleSortChange({ sortBy, sortAsc }) {
    if ((sortBy?.length ?? 0) === 0) {
      return;
    }
    let criteria = searchCriteria;
    criteria["sortBy"] = sortBy;
    criteria["sortAsc"] = sortAsc === "asc";

    setSearchCriteria(criteria);

    /// reset pag info
    //pagingInfoRef.current.resetPageInfo();
    //criteria = pagingInfoRef.current.buildFetch(criteria);
    store.pagingInfoRef.resetPageInfo();
    criteria = store.pagingInfoRef.buildFetch(criteria);
    searchFetchData(criteria);
  }

  useEffect(() => console.log(`GOGOGO rendered`));

  async function generateFile(event) {
    let criteria = searchCriteria;

    // - setIsLoading(true);

    const response = await api
      .searchOrdenesVentasCSV(criteria)
      .catch((error) => {
        toast.error("Error al buscar Ordenes Ventas.");
        setIsLoading(false);
      });
    if (!response) return;

    csvRef.current.downloadCSV(response.data, "ordenesVenta.csv");

    // - setIsLoading(false);
  }

  function generateFile2(event) {
    //TODO: generar CSV con los filtros seleccionados

    const csvString = [
      [
        "Id",
        "Nombre",
        "Asociado",
        "Alias",
        "Email",
        "Celular",
        "Calidad de Información",
        "Estatus",
      ], // Specify your headers here
      ...asociados.map((item) => {
        const nombre = buildName(item, true);

        const creditoDispuesto = Singleton.getInstance().format(item.credito);
        const limiteCredito = Singleton.getInstance().format(
          item.limiteCredito,
        );
        const creditoDispuestoPer = item.credDisPor;
        const creditoDisponible = Singleton.getInstance().format(
          item.creditoDisponible,
        );

        return [
          item.numAsociado ?? "",
          nombre,
          limiteCredito,
          creditoDispuesto,
          creditoDispuestoPer,
          creditoDisponible,
          item.nivel?.nombre,
          handleStatus(item).text,
        ];
      }),
    ] // Map your data fields accordingly
      .map((row) => row.join(","))
      .join("\n");

    csvRef.current.downloadCSV(csvString, "asociadosCatalogo.csv");
  }

  return (
    <div className="card recent-sales overflow-auto">
      <ExportCSV ref={csvRef} />

      <CreateAsociados
        ref={createAsociadosRef}
        item={modalData}
        reloadAsociados={reloadAsociados}
      />

      <ChangeCreditLimitModal ref={changeCreditLimitRef} item={modalData} />

      <ChangeLevelModal ref={changeLevelRef} item={modalData} />

      <ChangeCongeladoModal ref={changeCongeladoRef} item={modalData} />

      <div className="separator"></div>
      <div className="">
        <div
          className="container-fluid"
          style={{ paddingLeft: "20px", paddingRight: "20px" }}
        >
          <div className="header">
            <SearchBar onChange={(e) => onChangeSearchText(e)} />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "10px",
              gap: "10px",
            }}
          >
            <button
              className={`btn btn-info ${styles.tooltip}`}
              onClick={(event) => generateFile(event)}
              style={{ marginLeft: "0px" }}
              disabled={isLoading}
            >
              <div>
                <span className={`${styles.tooltiptext}`}>Descargar CSV</span>
                <MdOutlineFileDownload />
              </div>
            </button>
            <button
              className="btn btn-primary"
              onClick={createAsociado}
              hidden={!permissions.canCreate}
            >
              <div className={buttonStyles.icon_button}>
                <FaPlus />
                Crear Asociado
              </div>
            </button>
          </div>

          <Child2
            filtros={filtros}
            filtrosRef={filtrosRef}
            clearCallback={clearCallback}
            Menus={Menus}
            status={status}
            docu={docu}
            resizeRef={resizeRef}
            handleStatusClick={handleStatusClick}
            handleLimiteCreditoRangeChange={handleLimiteCreditoRangeChange}
            handleCreditoRangeChange={handleCreditoRangeChange}
            handleCreditoRangePercentageChange={
              handleCreditoRangePercentageChange
            }
            handleCreditoRangeDisponibleChange={
              handleCreditoRangeDisponibleChange
            }
            handleDocuClick={handleDocuClick}
            niveles={niveles}
            handleNivelesClick={handleNivelesClick}
          />
        </div>
      </div>

      <PagingBar />

      <div className="card-body">
        <AsociadosTable
          openItem={loadItem}
          openChangeCreditLimit={openChangeCreditLimit}
          openChangeLevel={openChangeLevel}
          openCongelarDescongelar={openCongelarDescongelar}
          handleSortChange={handleSortChange}
          isLoading={isLoading}
          reloadAsociados={reloadAsociados}
        />
      </div>
    </div>
  );
}
